/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import FormFieldEditor from '../helpers/FormFieldEditor';
import Infotip from '../../../uiold/Infotip';
import { Checkbox, Text } from '../../../uiold';

import MultichoiceElement from '../MultichoiceElement';
import OptionsEditor from './OptionsEditor';
import {
  Option,
  OptionsRuntype,
} from '../../../../runtypes/SignupFormDefinitionRuntype';

const emptyOptions: Array<Option> = [];

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValue: (key: string, newValue: unknown) => void;
  renderNameInput: () => ReactElement;
  renderLabelInput: () => ReactElement;
};

type EditorViewState = {
  optionsArray: Array<Option>;
};

function validateOptions(options: unknown) {
  if (!OptionsRuntype.guard(options)) {
    return undefined;
  }
  return options;
}

class EditorView extends Component<EditorViewProps, EditorViewState> {
  constructor(props: EditorViewProps) {
    super(props);
    const { options } = props.data;
    this.state = {
      optionsArray: validateOptions(options) ?? emptyOptions,
    };
  }

  componentDidUpdate(prevProps: EditorViewProps) {
    const oldOptions = validateOptions(prevProps.data.options) ?? emptyOptions;
    const newOptions = validateOptions(this.props.data.options) ?? emptyOptions;
    if (oldOptions !== newOptions) {
      this.setState({
        optionsArray: newOptions,
      });
    }
  }

  render() {
    let { data, updateValue, renderNameInput, renderLabelInput } = this.props;
    let { optionsArray } = this.state;
    return (
      <View style={styles.container}>
        {renderNameInput()}
        {renderLabelInput()}
        <View>
          <View style={styles.item}>
            <View style={styles.flexColumn}>
              <View style={[styles.inline, { zIndex: 2 }]}>
                <Text style={styles.fontNormal}>Choices</Text>
                <Infotip
                  width={200}
                  text='Use "item +amount" for automatic price estimate on the form. For example, "Electricity +30" adds $30.00 on the price estimate.'
                />
              </View>
              <OptionsEditor
                options={optionsArray}
                onChange={(optionsArray) => {
                  this.setState({ optionsArray });
                  this.props.updateValue('options', optionsArray);
                }}
              />
            </View>
          </View>
        </View>
        <Checkbox
          text="Required"
          isDisabled={!!data.isSystemField}
          isChecked={!!data.isSystemField || !!data.is_required}
          onChange={(value) => updateValue('is_required', value)}
        />
        <Checkbox
          text="Allow multiple selections"
          isChecked={data.condensed ? false : !!data.allow_multi}
          onChange={(value) => updateValue('allow_multi', value)}
        />
        <Checkbox
          text="Disable 'select all'"
          isChecked={data.allow_multi ? !!data.disable_select_all : false}
          onChange={(value) => updateValue('disable_select_all', value)}
        />
        <Checkbox
          text="Display as dropdown"
          isChecked={!!data.condensed}
          onChange={(value) => updateValue('condensed', value)}
        />
      </View>
    );
  }
}

type Props = {
  parent: MultichoiceElement;
};

class MultichoiceElementFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return (
      <FormFieldEditor
        component={EditorView}
        parent={parent}
        beforeDataUpdate={beforeDataUpdate}
      />
    );
  }
}

// This is called during updateValue() to filter the user input before
// updating state.
function beforeDataUpdate<
  T extends {
    [key: string]: any;
  }
>(updates: T): T {
  if (updates.condensed === true) {
    return { ...updates, allow_multi: false };
  } else if (updates.allow_multi === true) {
    return { ...updates, condensed: false };
  }
  return updates;
}

let styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
  },
  flexColumn: {
    flex: 1,
    flexDirection: 'column',
  },
  inline: {
    flexDirection: 'row',
    marginVertical: 5,
  },
  item: {
    flexDirection: 'row',
    marginVertical: 5,
  },
  fontNormal: {
    fontWeight: 'normal',
  },
});

export default MultichoiceElementFieldEditorView;
